import { render, staticRenderFns } from "./floatingButton.vue?vue&type=template&id=2f4fe3cb"
import script from "./floatingButton.vue?vue&type=script&lang=js"
export * from "./floatingButton.vue?vue&type=script&lang=js"
import style0 from "./floatingButton.vue?vue&type=style&index=0&id=2f4fe3cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports